module.exports = __webpack_public_path__ + "static/media/box_real.738a074e.jpg";